<template>
  <v-skeleton-loader
    :loading="realmSettingsLoading"
    type="list-item-avatar-two-line"
  >
    <div class="d-flex flex-row align-center justify-space-between sm-workspace-switch">
      <router-link
        v-if="showNetworkLogo"
        to="/"

        class="d-flex flex-row align-center workspace-switch-title"
      >
        <img
          :src="logo"
          class="logo"
        >
        <span
          class="text-body-1 text-black ml-12"
        >{{ networkName }}</span>
      </router-link>
      <v-menu
        v-if="(workspacesEnabled && hasWorkspaces) || showCurrNetwork "
        v-model="showMenu"
        content-class="workspaces-content "
        location="bottom right"
      >
        <template #activator="{ props, isActive }">
          <v-btn
            icon
            variant="flat"
            v-bind="props"
            class="text-secondary"
            @click="trackClickWorkspaceMenu()"
          >
            <slot name="icon">
              <v-icon>
                {{ isActive ? 'ico-sm-arrow-up' : 'ico-sm-arrow-down' }}
              </v-icon>
            </slot>
          </v-btn>
          <slot name="logo" />
        </template>

        <v-list width="240">
          <slot name="currNetwork" />
          <div v-if="workspacesEnabled && hasWorkspaces">
            <v-list-item
              v-for="(workspace, i) in listedWorkspaces"
              :key="i"
              :href="`https://${workspace.domain}`"
              class="py-4 align-center"
              @click="trackClickInWorkspaceMenu({list_position: i})"
            >
              <v-avatar
                size="40"
                class="mr-4"
              >
                <v-img :src="`https://${workspace.domain}/public/network-logo`" />
              </v-avatar>
              <div class="d-flex align-center">
                <span>{{ workspace.domain }}</span>
              </div>
            </v-list-item>
          </div>
        </v-list>
      </v-menu>
    </div>
  </v-skeleton-loader>
</template>
<script lang="ts">
import {
  computed, defineComponent, ref, watch
} from 'vue'
import useRealmSettings from '@src/composables/realmSettings'
import useWorkspaceSwitchTracking from './useWorkspaceSwitchTracking'

export default defineComponent({
  name: 'SMWorkspaceSwitch',
  props: {
    showNetworkLogo: {
      type: Boolean,
      default: true
    },
    showCurrNetwork: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const logo = '/public/network-logo'
    const showMenu = ref(false)
    const {
      realmSettings, realmSettingsLoading
    } = useRealmSettings()
    const {
      trackViewWorkspaceMenu,
      trackClickWorkspaceMenu,
      trackClickInWorkspaceMenu
    } = useWorkspaceSwitchTracking()

    const networkName = computed(() => realmSettings.value?.metadata?.realm_name)
    const listedWorkspaces = computed(() => realmSettings.value?.workspaces?.listed_workspaces)
    const workspacesEnabled = computed(() => realmSettings.value?.workspaces?.enabled)
    const hasWorkspaces = computed(() => !!listedWorkspaces?.value?.length)

    watch(showMenu, (shouldShowMenu) => {
      if (shouldShowMenu) {
        if (listedWorkspaces?.value) {
          trackViewWorkspaceMenu({ total_workspaces: listedWorkspaces?.value?.length })
        }
      }
    })

    return {
      networkName,
      logo,
      listedWorkspaces,
      workspacesEnabled,
      hasWorkspaces,
      realmSettingsLoading,
      showMenu,
      trackClickWorkspaceMenu,
      trackClickInWorkspaceMenu
    }
  }
})
</script>

<style lang="scss" scoped>
@use "~@styles/constants" as consts;

.logo {
  border-radius: 2px;
  max-height: 40px;
  position: absolute;
  background-color: consts.$color-background;
  z-index: 0;
}
.workspace-switch-title {
  height: 40px;
}
</style>
